// E.164-like validation with optional spaces and separators after the country code.
export const internationalPhoneNumberRegex = /^\+[1-9][0-9\s/()-]{6,20}$/;
export const germanPostalCodeRegex = /^\d{5}$/;
